export const en = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/2cd0d49d-6249-4773-a7f1-5d23c4609328.png',
};

export const ja = {
  titleImg: 'https://contents-virtual.eventxtra.com/uploads/reed902_staging/originals/203304dd-84b3-4f66-b0b6-b79e224f883f.png',
};
